module.exports = __webpack_public_path__ + "media/images/background-blueTexture-571dadf0.png";